import { render, staticRenderFns } from "./Zarota.vue?vue&type=template&id=6eb15052&scoped=true&"
import script from "./Zarota.vue?vue&type=script&lang=js&"
export * from "./Zarota.vue?vue&type=script&lang=js&"
import style0 from "./Zarota.vue?vue&type=style&index=0&id=6eb15052&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb15052",
  null
  
)

export default component.exports